import '../../styles/Container.css';

import React from 'react';

interface ContainerProps {
  children: React.ReactNode;
  className?: string;
}

const Container: React.FC<ContainerProps> = ({
  children,
  className = '',
}) => {
  return (
    <div className={`container ${className}`}>
      {children}
    </div>
  );
};

export default Container; 